import { useContext } from 'react'
import { useMobile } from 'src/hooks/useMobile'
import { SparklesIcon } from 'src/components/Icons/SparklesIcon'
import { dispatchAmplitudeEvent } from 'src/utils/amplitude'
import { getStandardObject } from 'src/utils/amplitude/getStandardObject'
import { useGlobalContext } from 'src/components/contexts/GlobalContext'

import { ProductContext } from '../../../contexts'
import './style.scss'

const SIMILARS_SECTION_ID = 'Produtos similares'

export const GoToSimilars = () => {
  const { currentSku } = useContext(ProductContext)
  const { isMobile } = useMobile()
  const { pageData } = useGlobalContext()

  if (currentSku.isAvailable) {
    return null
  }

  const sendClickEvent = () => {
    const standardObject = getStandardObject(pageData)

    dispatchAmplitudeEvent({
      eventName: 'Click Button',
      eventData: {
        ...standardObject,
        click_name: 'Encontrar produtos similares',
      },
    })
  }

  const scrollToSimilarsSection = () => {
    const similarsSection = document.getElementById(SIMILARS_SECTION_ID)

    if (similarsSection) {
      similarsSection.scrollIntoView({
        behavior: 'smooth',
        block: isMobile ? 'start' : 'center',
      })
    }
  }

  const handleClick = () => {
    sendClickEvent()
    scrollToSimilarsSection()
  }

  return (
    <button
      onClick={handleClick}
      className="go-to-similars w-full flex gap-2 p-3 rounded-md items-center no-underline text-restructure-primary-inverted text-font-size-3 leading-[18px] font-medium"
    >
      <div className="p-1 bg-white rounded-full">
        <SparklesIcon />
      </div>
      Encontrar produtos similares
    </button>
  )
}
